import React, {useEffect} from "react";
import EstimateTable from "./EstimateTable";
import {useApp} from "../../utils/global-contexts/AppContext";

const EstimateScreen = () => {

    const {setSelectedFinalBalance} = useApp()

    useEffect(() => {
        setSelectedFinalBalance(undefined);
    }, []);

    return (
        <EstimateTable/>

    );
};


export default EstimateScreen;
